import { useFetchSavedAnalysisReportQuery } from '../service';
import useFetchMultipleSavedReports from './useFetchMultipleSavedReports';

export default function useFetchSavedReportWithCompetitors(guid: string, url: string) {
    const {
        data: savedAnalysisReport,
        isLoading: isLoadingAnalysisReport,
        isError: isFetchSavedAnalysisError,
    } = useFetchSavedAnalysisReportQuery({ guid, url });

    const { data: competitorReports, isLoading: isLoadingCompetitorReports } = useFetchMultipleSavedReports(
        savedAnalysisReport ? { guids: savedAnalysisReport.competitor_guids, urls: savedAnalysisReport.competitor_urls } : { guids: [], urls: [] }
    );

    const isLoading = isLoadingAnalysisReport || isLoadingCompetitorReports;

    return {
        savedAnalysisReport,
        /**
         * A map grouping each competitor report by the competitor url
         */
        competitorReports,
        isLoading,
        isError: isFetchSavedAnalysisError,
    };
}
